import { render, staticRenderFns } from "./StatementsJointTable.vue?vue&type=template&id=8a3c0d3c&"
import script from "./StatementsJointTable.vue?vue&type=script&lang=ts&"
export * from "./StatementsJointTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports